import { type Customer } from "@repo/api";
import { Badge, LightMode, Text } from "@repo/skapa";
import { T, t } from "@repo/translation";

import { FlexDiv } from "./FlexDiv";
import { Name } from "./Name";

export const CustomerName = ({ customer }: { customer?: Customer }) => {
  const registeredLabel = () => {
    if (customer && customer.customerAccountState !== "REGISTERED") {
      return false;
    }
    return (
      <Text textStyle="Heading.XS" color={LightMode.colourStaticIkeaFamily}>
        <T translationKey="label.registered" />
      </Text>
    );
  };
  return (
    <FlexDiv flexDirection="column">
      <FlexDiv justifyContent="space-between">
        {customer ? (
          <Text textStyle="Heading.XS">
            {customer.customerType === "Business" ? (
              customer.organizationName
            ) : (
              <Name
                firstName={customer.firstName}
                lastName={customer.lastName}
              />
            )}
          </Text>
        ) : (
          "-"
        )}
        <FlexDiv justifyContent="space-between" gap="2px">
          {customer?.customerType === "Business" && (
            <Badge
              colour="IKEABusinessNetwork"
              label={t("customer_type.business")}
              size="small"
            />
          )}
          {registeredLabel()}
        </FlexDiv>
      </FlexDiv>
    </FlexDiv>
  );
};
